import { Box, useColorMode } from "@chakra-ui/react";
import { useMemo } from "react";
import environment from "src/utils/environment";
import { themes } from "./getNamedTheme";

const { appName } = environment;

export function DarkMode({ children, active = true, adjuster, ...rest }) {
  const colors = themes[`${appName}-dark`].colors;

  const adjustments = useMemo(() => {
    return adjuster ? adjuster(colors) : {};
  }, [adjuster, colors]);

  const darkStyles = Object.entries({ ...colors, ...adjustments }).reduce(
    (all, entry) => {
      const [key, value] = entry;
      all[`--chakra-colors-${key}`] = value;
      return all;
    },
    {}
  );

  return (
    <Box sx={active ? darkStyles : undefined} {...rest}>
      {children}
    </Box>
  );
}

export function LightMode({ children, active = true, adjuster, ...rest }) {
  const colors = themes[`${appName}-light`].colors;

  const adjustments = useMemo(() => {
    return adjuster ? adjuster(colors) : {};
  }, [adjuster, colors]);

  const lightStyles = Object.entries({ ...colors, ...adjustments }).reduce(
    (all, entry) => {
      const [key, value] = entry;
      all[`--chakra-colors-${key}`] = value;
      return all;
    },
    {}
  );

  return (
    <Box sx={active ? lightStyles : undefined} {...rest}>
      {children}
    </Box>
  );
}

export function ThemeAdjuster({ children, adjuster, ...rest }) {
  const { colorMode } = useColorMode();
  const colors = themes[`${appName}-${colorMode}`].colors;

  const adjustments = useMemo(() => {
    return adjuster(colors);
  }, [adjuster, colors]);

  const adjustedStyles = Object.entries(adjustments).reduce((all, entry) => {
    const [key, value] = entry;
    all[`--chakra-colors-${key}`] = value;
    return all;
  }, {});

  return (
    <Box sx={adjustedStyles} {...rest}>
      {children}
    </Box>
  );
}
